<template>
    <div id="app">
        <loading v-show="isLoading"></loading>
        <router-view />
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Loading from './views/Loading'
export default {
    name:'App',
    components:{
        Loading
    },
    data () {
        return {
            navHighs:'100%',
            Loading: true,
            defaultHeight: document.body.clientHeight,
            screenHeight: document.body.clientHeight
        }
    },
    computed: {
        userInfo () {
            return this.$store.state.userInfo
        },
    },
    watch:{
        screenHeight(val) {
            if(!this.timer) {
                this.screenHeight = val
                this.timer = true
                let that = this
                setTimeout(function() {
                    if(that.screenHeight < that.defaultHeight) {
                        that.navHighs = that.defaultHeight +'px';
                    } else {
                        that.navHighs="100%";
                    }
                    that.timer = false
                },400)
            }
        }
    },
    methods:{
        clearReadDot() {
            this.$http.get('/appUser/resetNotice',{
                params: {
                    'app_id': this.$utils.getUrlKey('app_id'),
                    'username':this.$utils.getUrlKey('username')
                }
            }).then((response) => {
            }).catch((error) => {
                return false
            });
        }
    },
    mounted() {
        this.isLoading = false;
        
        const that = this
        window.onresize = () => {
            return (() => {
                window.screenHeight = document.body.clientHeight
                that.screenHeight = window.screenHeight
            }) ()
        };
    },
    created () {
        this.clearReadDot();
        this.isLoading = true;
        // const height = document.documentElement.clientHeight;
        // window.onload = function () {
        //     document.getElementById('app').style.height = `${height}px`;
        // }
    }
}
</script>
<style>
#app {
    font-family: '黑体' !important;
}
</style>
